<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-card class="elevation-6">
            <v-card-text>
                <v-toolbar flat color="white">
                    <v-toolbar-title>Συγγράμματα</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                    v-on="on"
                                    small
                                    fab
                                    color="primary"
                                    @click="addNewBook">
                                <v-icon large color="white">add</v-icon>
                            </v-btn>
                        </template>
                        <span>Προσθήκη νέου Συγγράμματος</span>
                    </v-tooltip>
                </v-toolbar>

                <v-divider></v-divider>

                <v-card-title>
                    <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Search"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                        no-data-text="Δεν υπάρχουν δεδομένα."
                        :headers="headers"
                        :items="$store.getters.publisherBooks"
                        :search="search">

                    <template v-slot:item="{ item }">

                        <tr :class="item.id == selectedBookId ? 'primary white--text' : ''" @click="selectLine(item)">
                            <td class="text-xs-right" @click="getAction(item, true)">{{ item.id }}</td>
                            <td class="text-xs-right" @click="getAction(item, true)">{{ item.title}}</td>
                            <td class="text-center">

                                <v-tooltip right>
                                    <template v-slot:activator="{ on }">
                                        <v-icon size="27" v-on="on" @click="bookToggleActive(item)"
                                                :color="item.active? 'yellow darken-1' : 'indianRed'">mdi-power
                                        </v-icon>
                                    </template>
                                    <span>Ενεργοποίηση / Απενενεργοποίηση</span>
                                </v-tooltip>

                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon :disabled="item.groupBooksSize > 0 ? true : false"
                                                @click="getAction(item, false)"
                                                color="red"
                                                class="mr-3"
                                                v-on="on">
                                            delete
                                        </v-icon>
                                    </template>
                                    <span>Διαγραφή Συγγράμματος</span>
                                </v-tooltip>
                            </td>
                        </tr>

                    </template>

                </v-data-table>

            </v-card-text>

        </v-card>

        <v-dialog
                v-model="dialog"
                width="500">

            <v-card>
                <v-card-title
                        class="headline primary white--text"
                        primary-title>
                    Επιβεβαίωση
                </v-card-title>

                <v-card-text class="mt-5">
                    <p>Διαγραφή Βιβλίου;</p>
                    <p class="red--text">{{title}}</p>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            text
                            @click="dialog = false">
                        Ακύρωση
                    </v-btn>
                    <v-btn
                            color="primary"
                            text
                            @click="deleteBook">
                        Διαγραφή
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

    import {eventBus} from "../../../main";
    import request from "../../../requests"
    import utils from "../../../utilities"

    export default {
        name: "AllocatorBooksTable",
        data: () => ({
            search: '',
            dialog: false,
            title: '',
            id: '',
            selectedBookId: '',
            headers: [
                {
                    text: 'Κωδικός',
                    align: 'start',
                    filterable: true,
                    value: 'id',
                },
                { text: 'Τίτλος', value: 'title', align: 'center'},
                { text: 'Ενέργειες', value: 'fat', align: 'center', width:150, sortable: false },
            ],
        }),

        methods: {

	        bookToggleActive(item) {
		        document.activeElement.blur();
		        this.$store.commit('setLoadingModal', true);
		        let book = {};
		        book.id = item.id;
		        book.active = !item.active;
		        request.put('rest/allocator/book/activate-deactivate', book, (resp)=>{
			        this.$store.commit('setLoadingModal', false);
			        this.$store.commit('setPublisherBooks', resp);
                });
	        },

            selectLine(item){
                this.selectedBookId = item.id;
            },

            getAction(item, deleteORedit){

                this.$store.commit('setEditPublisherBook', item);
                if (deleteORedit) {
                //    edit
                    eventBus.$emit('createEditAllocatorFields', true);
                    return
                }


                this.$store.commit('setEditPublisherBook', item);
                this.title = item.title;
                this.id = Number(item.id);
                this.dialog = true;
                eventBus.$emit('deleteAllocatorItem');
            },

            // delete the current book
            deleteBook() {
                this.dialog = false;
                var token = utils.getLocalStorage('token');
                if (token != null) {
                    this.$store.commit('setLoadingModal', true);
                    request.deleteBook(token, this.id, this.deleteBookCallBack)
                }
                else {
                    this.$store.commit('setloginModal', true);
                }
            },

            deleteBookCallBack(response) {
                this.selectedBookId = '';
                this.$store.commit('setPublisherBooks', response.bookList);
                this.$store.commit('setLoadingModal', false);
            },

            //add new book
            addNewBook() {
                var token = utils.getLocalStorage('token');
                if (token != null) {
                    var bookObj = {
                        type: 'ProfessorNotes',
                        active: true
                    };
                    this.$store.commit('setLoadingModal', true);
                    request.addNewBook(token, bookObj,  this.addNewBookCallBack)
                }
                else {
                    this.$store.commit('setloginModal', true);
                }
            },

            addNewBookCallBack(response) {

                this.$store.commit('setEditPublisherBook', response);
                var books = this.$store.getters.publisherBooks;
                books.push(response);
                this.$store.commit('setPublisherBooks', books);
                eventBus.$emit('addNewAllocatorBook');
                this.$store.commit('setLoadingModal', false);
            },
            //get all publisher books
            getAllPublisherBooks() {
                var token = utils.getLocalStorage('token');
                if (token != null) {
                    this.$store.commit('setLoadingModal', true);
                    request.getAllPublisherBooks(token, this.getAllPublisherBooksCallBack);
                }
                else {
                    this.$store.commit('setloginModal', true);
                }
            },

            //call back publisher Books
            getAllPublisherBooksCallBack(response) {

                this.$store.commit('setLoadingModal', false);
                this.$store.commit('setPublisherBooks', response);
            }
        },
        mounted() {
            this.getAllPublisherBooks();
            //console.log('aloc books table mounted');
        },
    }
</script>

<style scoped>

</style>